// extracted by mini-css-extract-plugin
export var mediaCard = "index-module--mediaCard--DoVSv";
export var mediaContent = "index-module--mediaContent--OjhMR";
export var mediaLeft = "index-module--mediaLeft--5-fzq";